import ModalStack from "../Components/Modal";

const Module2 = () => {
  return (
    <>
      <ModalStack /> hi
    </>
  );
};

export default Module2;
